import { SelectItem, SelectSeparator } from "@prismicio/editor-ui"

import { useRequestRepository } from "../../../hooks/useRequestRepository"
import { useAPIExplorer } from "../../APIExplorerContext"
import { RequestFormInput } from "./RequestFormInput"
import { RequestFormSelect } from "./RequestFormSelect"

/**
 * Represents the default master ref value (`undefined`) for Radix UI `<SelectItem />` which does not accept falsy values for an item's value.
 */
const selectItemRefDefault = "selectItemRefDefault"

/**
 * Display a fieldset managing a request ref setting.
 */
export function RequestRefFieldset() {
  const { request } = useAPIExplorer()

  const repository = useRequestRepository()

  if (!repository || repository.refs.length === 0) {
    return <RequestRefFielsetFreeForm />
  }

  function setRef(ref: string) {
    request.setRef(ref === selectItemRefDefault ? undefined : ref)
  }

  function humanReadableRef(ref?: string) {
    if (!ref) {
      return "Default (latest content)"
    }

    const maybeRef = repository?.refs.find(({ ref: _ref }) => _ref === ref)

    if (!maybeRef) {
      return ref
    }

    return `${maybeRef.label} (${maybeRef.ref})`
  }

  return (
    <RequestFormSelect
      label="REF"
      value={request.ref ?? ""}
      onValueChange={setRef}
      placeholder={humanReadableRef()}
    >
      <SelectItem key={selectItemRefDefault} value={selectItemRefDefault}>
        {humanReadableRef()}
      </SelectItem>
      <SelectSeparator />
      {repository?.refs.map(({ ref }) => (
        <SelectItem key={ref} value={ref}>
          {humanReadableRef(ref)}
        </SelectItem>
      ))}
    </RequestFormSelect>
  )
}

function RequestRefFielsetFreeForm() {
  const { request } = useAPIExplorer()

  return (
    <RequestFormInput
      value={request.ref ?? ""}
      onValueChange={request.setRef}
      label="REF"
      placeholder="Default (master)"
    />
  )
}
